// extracted by mini-css-extract-plugin
export default {"error":"ErrorPage_error__5zzMa","errorMonster":"ErrorPage_errorMonster__hhDGZ"};